module.exports = __webpack_public_path__ + "2791aa988d659ef157ee0a22fc185d5a.png";